import { BUFFERED_REQUEST_STORAGE_PREFIX } from '@shared/extension/constants';
import { processDelayedStoredRequests } from '@shared/extension/utils/stored-requests';
import { postToBackendFromLocalStorage } from '@shared/http/utils/post-to-backend-from-local-storage';
import { ONE_MINUTE_MS } from '@shared/utils/constants';
import { Services } from '../services';
import { LogLevel } from '@environment/enums/log-level.enum';
import { captureSentryMessage } from '@shared/sentry';

const PROCESS_DELAYED_STORED_REQUESTS_INTERVAL = ONE_MINUTE_MS;

export function startHandlingStoredRequests(services: Services): void {
  chrome.storage.onChanged.addListener(async (changes, areaName) => {
    if (areaName === 'local') {
      for (let key in changes) {
        if (key.startsWith(BUFFERED_REQUEST_STORAGE_PREFIX)) {
          captureSentryMessage(`Storage changed for key ${key}`, {
            newValue: changes[key]?.newValue,
            oldValue: changes[key]?.oldValue,
          }, LogLevel.Trace);
          if (changes[key]?.newValue && !changes[key]?.oldValue) {
            captureSentryMessage(`Found new stored request ${key}, processing...`, {}, LogLevel.Debug);
            await postToBackendFromLocalStorage(key, services.commonStore.backendUrl$.value, 'onChanged-stored-requests-handler');
          } else if (!changes[key]?.newValue && changes[key]?.oldValue) {
            captureSentryMessage(`Request ${key} was removed from storage`, {}, LogLevel.Debug);
          }
        }
      }
    }
  });

  setInterval(() => {
    processDelayedStoredRequests(services.commonStore.backendUrl$.value, 'onInterval-stored-requests-handler');
  }, PROCESS_DELAYED_STORED_REQUESTS_INTERVAL);

  services.networkService.isOnline$.subscribe(isOnline => {
    if (isOnline) {
      console.log(`Network is back, processing delayed stored requests`);
      processDelayedStoredRequests(services.commonStore.backendUrl$.value, 'networkService.isOnline-stored-requests-handler');
    }
  });
}
